// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PrintInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="15"
            fill="currentColor"
        >
            <path
                d="M561.25,626 L550.75,626 C549.783398,626 549,626.784766 549,627.75 L549,630.375 C549,630.858164 549.391836,631.25 549.875,631.25 L550.75,631.25 L550.75,633.875 C550.75,634.358164 551.141836,634.75 551.625,634.75 L560.375,634.75 C560.858164,634.75 561.25,634.358164 561.25,633.875 L561.25,631.25 L562.125,631.25 C562.608164,631.25 563,630.858164 563,630.375 L563,627.75 C563,626.784766 562.215234,626 561.25,626 Z M559.5,633 L552.5,633 L552.5,630.375 L559.5,630.375 L559.5,633 Z M560.8125,628.84375 C560.450195,628.84375 560.15625,628.549805 560.15625,628.1875 C560.15625,627.824649 560.450195,627.53125 560.8125,627.53125 C561.174805,627.53125 561.46875,627.824649 561.46875,628.1875 C561.46875,628.551172 561.176172,628.84375 560.8125,628.84375 Z M552.5,622.5 L558.775391,622.5 L559.5,623.224883 L559.5,625.125 L561.25,625.125 L561.25,622.862305 C561.25,622.63032 561.157715,622.407852 560.993652,622.243789 L559.756348,621.006485 C559.592969,620.842285 559.36875,620.75 559.139062,620.75 L551.625,620.75 C551.142109,620.75 550.75,621.141836 550.75,621.625 L550.75,625.125 L552.5,625.125 L552.5,622.5 Z"
                opacity=".66"
                transform="translate(-549 -620)"
            />
        </svg>
    );
};

export default React.memo(PrintInactive);
